export function getIconStyle(item) {
    let iconUrl = getIllustrationUrl(item);
    let style = iconUrl ? "background-image: url('" + iconUrl + "');" : '';
    return style;
}

export function getIllustrationUrl(item) {
    return item.illustration_src ? item.illustration_src : '';
}